import * as Mustache from 'mustache';
import * as moment from 'moment';
import { Role } from '../../pages/admin/icontact/setting/expert/agent/agent.const';

export class FileWorker {
  formatBytes = (bytes: number, decimals = 2): string => {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };
  formatNameFile = (input: string) => {
    const path = input.split('?')[0];
    const segments = path.split('/');
    const fileName = segments.pop();

    // Bước 2: Xử lý tên file
    const maxLength = 20; // Độ dài tối đa cho tên file trước khi thêm '...'
    const extension = fileName.split('.').pop();
    const baseName = fileName.slice(0, -(extension.length + 1));

    if (baseName.length <= maxLength) {
      return fileName;
    }

    const truncatedBaseName = baseName.slice(0, maxLength / 2) + '...' + baseName.slice(-maxLength / 2);

    return truncatedBaseName + '.' + extension;
  };
}

export function showPhoneNumberInString(input, user) {
  const phoneRegex =
    /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d| 2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]| 4[987654310]|3[9643210]|2[70]|7|1)\d|[0123]\d{6,15}[+\-_?@!*]?/g;
  if (!input) {
    return '';
  }
  const tenantUsed = [
    '66bc0f7bbb442d077700d499',
    '646ae9cffe32b43426f45165',
    '66fa5789e86cb700f839c36e',
    '6693ba2555b3c3049fc65539',
    '66fa5b04e86cb700f83a4b46',
    '66fa5336e86cb700f8391f21',
  ];
  if (
    (tenantUsed.includes(user.tenant_id) && user && user.role === Role.Agent) ||
    (user && user.email === 'adminleader@newlandtravel.vn')
  ) {
    return input.replace(phoneRegex, match => {
      if (!/[+\-_?@!*]/.test(match)) {
        return match.slice(0, -3) + '***';
      }
      return match;
    });
  } else {
    return input;
  }
}

export function generateKey(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function formatDob(dob: string) {
  return !dob ? '' : moment(dob, 'YYYY-MM-DD').format('YYYY-MM-DD');
}

export function isMongoDBObjectId(text) {
  const mongoIdRegex = /^[a-fA-F0-9]{24}$/;
  return mongoIdRegex.test(text);
}



// WEBPACK FOOTER //
// ./src/app/common/utils/common.ts